import {
  GET_INVENTORY_ITEMS_DATA,
  GET_INVENTORY_ITEMS_LOADER
} from "../../constants/ActionTypes";

const initialSettings = {
  getInventoryProductData : [],
  loader : true,
  
};

const Inventory = (state = initialSettings, action) => {
  switch (action.type) {
    //**********Inventory Count************
    case GET_INVENTORY_ITEMS_DATA:
      return {
        ...state,
        getInventoryProductData: action.payload,
      };
      case GET_INVENTORY_ITEMS_LOADER:
      return {
        ...state,
        loader : action.payload,
      };
    default:
      return state;
  }
};

export default Inventory;
